import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class CartaPorteMercanciaPedimentosForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  rules(data) {
    return {
      'Pedimento': ['string', 'size:21']
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      pedimentos: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, data = {} } = this.state;

    return (
      <>
        <Row>
        <Col sm md={ 4 }>
            <FormControl type="text"
              label="Pedimento"
              name="Pedimento"
              placeholder=""
              help=""
              minLength="21"
              maxLength="21"
              rules={ rules.Pedimento }
              value={ data.Pedimento }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar pedimento
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteMercanciaPedimentosForm;